<template>
  <div>
    <div class="table">
      <el-table :data="tableData" class="table_width">
        <el-table-column :label="$t('administrator.id')" prop="id" width="50"></el-table-column>
        <el-table-column :label="$t('administrator.userName')" prop="name"></el-table-column>
        <el-table-column :label="$t('administrator.source')" prop="way"></el-table-column>
        <el-table-column :label="$t('administrator.agreementVersion')" prop="agreementVersion"></el-table-column>
        <el-table-column :label="$t('administrator.remark')" prop="remark"></el-table-column>
        <el-table-column :label="$t('administrator.createTime')" prop="createTime"></el-table-column>
        <el-table-column :label="$t('administrator.operation')">
          <template slot-scope="scope">
            <el-button v-if="scope.row.roleId === roleNormal" type="text"
                       @click="dialogModifyUserName(scope.row)">
              {{ $t('administrator.remarkBtn') }}
            </el-button>

            <el-button v-if="scope.row.roleId === roleNormal" type="text"
                       @click="modifyUserRole(scope.row.id, 1)">
              {{ $t('administrator.setAdmin') }}
            </el-button>
            <el-button v-if="scope.row.roleId === roleAdmin" type="text"
                       @click="modifyUserRole(scope.row.id, 3)">
              {{ $t('administrator.cancelAdmin') }}
            </el-button>

            <el-button v-if="scope.row.roleId === roleNormal" type="text"
                       @click="modifyUserRole(scope.row.id, 2)">
              {{ $t('administrator.banUser') }}
            </el-button>
            <el-button v-if="scope.row.roleId === roleBlackList" type="text"
                       @click="modifyUserRole(scope.row.id, 4)">
              {{ $t('administrator.unbanUser') }}
            </el-button>
            <el-button :disabled="scope.row.roleId === roleAdmin" type="text"
                       @click="deleteUser(scope.row.id)">
              {{ $t('administrator.deleteUser') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :page-size="10"
        :page-sizes="[10, 20, 50, 100]"
        :total="tableDataTotal"
        align="right"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="onCurrentChange"
      >
      </el-pagination>
      <el-dialog
        :close-on-click-modal="false"
        :title="$t('administrator.remark')"
        :visible.sync="remarkVisible"
        width="400px"
      >
        <el-input v-model="remark" :placeholder="$t('administrator.inputRemark')"
                  :rows="3" type="textarea"></el-input>
        <span slot="footer" class="dialog-footer">
        <el-button @click="remarkVisible = false">{{ $t('administrator.cancel') }}</el-button>
        <el-button type="primary" @click="modifyUserName">{{ $t('administrator.confirm') }}</el-button>
      </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {getRequest, postRequest} from '@/common/libs/request';
import {Message} from 'element-ui';
import {roleAdmin, roleBlackList, roleNormal} from '@/common/constants';

export default {
  name: 'administrator',
  data() {
    return {
      tableData: [],
      pageIndex: 1,
      pageLimit: 10,
      tableDataTotal: 0,
      roleList: [],
      roleAdmin,
      roleNormal,
      roleBlackList,
      userId: null,
      remark: null,
      remarkVisible: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      const offset = this.pageLimit * (this.pageIndex - 1);
      getRequest(`/api/eda/common/admin/getUserList?offset=${offset}&limit=${this.pageLimit}`).then((res) => {
        this.tableData = res.list;
        this.tableDataTotal = res.total;
      });
    },
    deleteUser(id) {
      this.$confirm(this.$t('administrator.deleteConfirm'), this.$t('administrator.deleteMember'), {
        confirmButtonText: this.$t('administrator.confirm'),
      }).then(() => {
        postRequest('/api/eda/common/admin/deleteUser', {userId: +id}).then(() => {
          this.getList();
          Message.success(this.$t('administrator.deleteSuccess'));
        });
      });
    },
    dialogModifyUserName({id, remark}) {
      this.userId = id;
      this.remark = remark || '';
      this.remarkVisible = true;
    },
    modifyUserName() {
      postRequest('/api/eda/common/admin/modifyUser', {
        userId: this.userId,
        remark: this.remark,
      }).then(() => {
        Message.success(this.$t('administrator.addRemarkSuccess'));
        this.remarkVisible = false;
        this.getList();
      });
    },
    async modifyUserRole(id, roleId) {
      let confirmInfo = {
        massage: '',
        title: '',
      };

      switch (roleId) {
        case 1:
          confirmInfo = {
            massage: this.$t('administrator.setAdminConfirm'),
            title: this.$t('administrator.setAdmin'),
          };
          break;
        case 2:
          confirmInfo = {
            massage: this.$t('administrator.banUserConfirm'),
            title: this.$t('administrator.banUser'),
          };
          break;
        case 3:
          confirmInfo = {
            massage: this.$t('administrator.cancelAdminConfirm'),
            title: this.$t('administrator.cancelAdmin'),
          };
          break;
        default:
          confirmInfo = {
            massage: this.$t('administrator.unbanUserConfirm'),
            title: this.$t('administrator.unbanUser'),
          };
          roleId = 3;
          break;
      }

      await this.$confirm(`${confirmInfo.massage}`, `${confirmInfo.title}`, {
        confirmButtonText: this.$t('administrator.confirm'),
        cancelButtonText: this.$t('common.cancel'),
      }).then(() => {
        postRequest('/api/eda/common/admin/modifyUserRole', {userId: +id, roleId}).then(() => {
          this.getList();
          Message.success(`${confirmInfo.title}${this.$t('administrator.success')}`);
        });
      }).catch(() => {
        console.log('cancel');
      });
    },
    onCurrentChange(val) {
      this.pageIndex = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageLimit = val;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.table_width {
  width: 100%;
}

// table 背景颜色+padding10px
.table {
  background: #fff;
  padding: 10px;
  // table内容部分下边距和最小高度
  .el-table {
    margin-bottom: 10px;
    min-height: 264px;
  }
}

.spanCls {
  width: 50px;
  line-height: 40px;
}
</style>
